import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      d: "M12.142 7.5A6.64 6.64 0 0 0 9.75 5.34c.952-.965 1.5-2.455 1.5-4.34a1 1 0 0 0-1-1H3.04a1 1 0 0 0-1 1c0 1.888.532 3.378 1.482 4.343A6.64 6.64 0 0 0 0 11.2a7.15 7.15 0 0 0 1.52 4.438 1 1 0 0 0 .77.362h5.5a1 1 0 0 0 0-2H2.797A5.43 5.43 0 0 1 2 11.2a4.645 4.645 0 0 1 4.585-4.635h.117a4.64 4.64 0 0 1 3.783 2.042A1 1 0 0 0 12.142 7.5M4.102 2h5.07c-.277 2.037-1.432 2.54-2.45 2.565h-.177C5.53 4.537 4.38 4.032 4.102 2",
      class: "fill-secondary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M15 12.5h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2M15 16h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2",
      class: "fill-primary"
    }, null, -1)
  ])))
}
export default { render: render }